import React, { useState } from "react";
import styled from "styled-components";
import { space } from "../common/variables";
import Search from "./Search/Search";

const SearchBar = ({
    initialValue,
    onEnterPress,
    placeholder,
}: {
    initialValue?: string;
    onEnterPress: (value: string) => void;
    placeholder: string;
}) => {
    const [input, setInput] = useState(initialValue || "");

    return (
        <Wrapper>
            <Search
                size="large"
                inputPlaceholder={placeholder}
                inputText={input}
                setInputText={setInput}
                onReset={() => {
                    setInput("");
                    onEnterPress("");
                }}
                onEnterPress={() => onEnterPress(input)}
                useDropdown={false}
            />
        </Wrapper>
    );
};

const Wrapper = styled.div`
    margin-bottom: ${space.large};
`;

export default SearchBar;
